import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ButtonS1 from "./ButtonS1";
import {
  applyClarityStatisticsConsent,
  clarityStatisticsConsentValues,
  getStoredClarityStatisticsConsent,
  setStoredClarityStatisticsConsent,
} from "../../../clarityConsent";
import "./cookieConsentBanner.css";

const CookieConsentBanner = () => {
  const [statisticsConsent, setStatisticsConsent] = useState(() =>
    getStoredClarityStatisticsConsent()
  );
  const [showBanner, setShowBanner] = useState(
    () => getStoredClarityStatisticsConsent() === null
  );

  useEffect(() => {
    applyClarityStatisticsConsent(
      statisticsConsent ?? clarityStatisticsConsentValues.denied
    );
  }, [statisticsConsent]);

  const saveConsentChoice = (consentValue) => {
    setStoredClarityStatisticsConsent(consentValue);
    setStatisticsConsent(consentValue);
    setShowBanner(false);
  };

  return (
    <Modal
      show={showBanner}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="cookieConsentDialog"
    >
      <Modal.Header className="cookieConsentHeader">
        <Modal.Title className="cookieConsentTitle">
          Om kakor (cookies)
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="cookieConsentBody">
        Eltel Networks Infranet AB sparar information på din enhet via kakor för
        att kunna erbjuda kundanpassad funktionalitet, samla in besöksstatistik
        och erbjuda en förbättrad kundupplevelse. Du väljer vilka kakor du
        accepterar, utöver de som behövs för att vår kundportal ska fungera.
      </Modal.Body>
      <Modal.Footer className="cookieConsentFooter">
        <div className="cookieConsentActions">
          <ButtonS1
            text="Endast nödvändiga"
            clickButton={() =>
              saveConsentChoice(clarityStatisticsConsentValues.denied)
            }
            variant="outline"
            pos="cookieConsentButton"
          />
          <ButtonS1
            text="Acceptera alla"
            clickButton={() =>
              saveConsentChoice(clarityStatisticsConsentValues.granted)
            }
            pos="cookieConsentButton"
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CookieConsentBanner;
